import { Y42FeatureTypeToChildLogo, Y42FeatureTypeToLogo } from '@y42/feature';
import { Y42Route, Y42Routes } from '@y42/feature/routing';
import { DataLineageNodeTypes, Y42FeatureType } from '@y42/json-schema';
import { DataLineageUINode } from './data-lineage-diagram.model';

export const isTypeDatasource = (activeNode: DataLineageUINode) =>
  [DataLineageNodeTypes.Integration, DataLineageNodeTypes.UiModel, DataLineageNodeTypes.SqlModel].includes(
    activeNode.category,
  );

export const DataLineageNodeTypeToLogo: Record<DataLineageNodeTypes, string> = {
  [DataLineageNodeTypes.Integration]: Y42FeatureTypeToLogo[Y42FeatureType.Integration],
  [DataLineageNodeTypes.UiModel]: Y42FeatureTypeToLogo[Y42FeatureType.UiModel],
  [DataLineageNodeTypes.SqlModel]: Y42FeatureTypeToLogo[Y42FeatureType.SqlModel],
  [DataLineageNodeTypes.Dashboard]: Y42FeatureTypeToLogo[Y42FeatureType.VisualizationDashboard],
  [DataLineageNodeTypes.DashboardTab]: Y42FeatureTypeToChildLogo[Y42FeatureType.VisualizationDashboard],
  [DataLineageNodeTypes.Widget]: Y42FeatureTypeToLogo[Y42FeatureType.VisualizationWidget],
  [DataLineageNodeTypes.Export]: Y42FeatureTypeToLogo[Y42FeatureType.Export],
  [DataLineageNodeTypes.Empty]: '',
};

export const DataLineageNodeTypeToRoute: Record<DataLineageNodeTypes, Y42Route | null> = {
  [DataLineageNodeTypes.Integration]: Y42Routes.Integration,
  [DataLineageNodeTypes.UiModel]: Y42Routes.UiModeling,
  [DataLineageNodeTypes.SqlModel]: Y42Routes.SqlModeling,
  [DataLineageNodeTypes.Dashboard]: Y42Routes.VisualizationDashboard,
  [DataLineageNodeTypes.DashboardTab]: null,
  [DataLineageNodeTypes.Widget]: Y42Routes.VisualizationWidget,
  [DataLineageNodeTypes.Export]: Y42Routes.Export,
  [DataLineageNodeTypes.Empty]: null,
};
